import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'usdMoney'
})
export class UsdMoneyPipe implements PipeTransform {
  transform(value: any): string {
    if (value === null || value === undefined || value === '') return '';

    let numericValue = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;

    if (isNaN(numericValue)) return '';

    return '$' + numericValue.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
}
